export default __webpack_public_path__ + "static/bncff-screens-cbdc1dd8e4a2ae69969a8d77a646633a.jpg";